import React, { FC } from 'react';
import { TermsOfUse } from 'templates/company';
import { SEO } from 'templates/layout';

const Terms: FC = () => {
  return (
    <>
      <SEO title="Terms of use" />
      <TermsOfUse />
    </>
  );
};

export default Terms;
